import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';
import LoginBG from '../assets/images/login/login-bg.png';

// Container for the entire login page
export const LoginContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '100vh',
  backgroundColor: '#f4f6f9', // Light background for the form

  // Responsive Styles
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    height: '100%'
  },
}));

// Left Section for the image
export const LoginImageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '50%',
  backgroundColor: '#E2723C',
  backgroundImage: `url(${LoginBG})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '100vh',
  padding: theme.spacing(3),

  '.login-text-wrapper': {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',  
    textAlign: 'center',
    borderRadius: '15px',
    padding: theme.spacing(2),
  },
  '.login-text': {
    color: '#fff',
    fontWeight: 'bold',
  },

  // Responsive Styles
  [theme.breakpoints.down('md')]: {
    width: '100%', // Take full width on smaller screens
    height: '50vh',
  },
  [theme.breakpoints.down('sm')]: {
    height: '40vh',
  },
}));

// Right Section with the login form
export const LoginForm = styled(Box)(({ theme }) => ({
  width: '50%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(4),
  textAlign: 'center',

  '.login-form-title': {
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    color: '#2c5296',
  },
  '.login-form-subtitle': {
    marginBottom: theme.spacing(4),
    color: '#666',
  },
  '.icon': {
    color: '#aaa',
    marginRight: theme.spacing(1),
  },

  // Responsive Styles
  [theme.breakpoints.down('md')]: {
    width: '50%', // Full width on small screens
    padding: theme.spacing(2),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
    width: '75%'
  },
}));

// Login Image
export const LoginImage = styled('img')(({ theme }) => ({
  width: '100%',
  maxWidth: '300px',
  borderRadius: '15px',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

// Styled login button
export const LoginButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(3),
  fontWeight: 'bold',
  backgroundColor: '#E2723C',
  padding: '12px 0',
  borderRadius: '8px',
  textTransform: 'none',
  alignSelf: 'center',
  '&:hover': {
    backgroundColor: '#d05f2b',
  },

  // Responsive Styles
  [theme.breakpoints.down('md')]: {
    // Use theme for button font size if necessary
  },
  [theme.breakpoints.down('sm')]: {
    padding: '10px 0',
  },
}));
